// extracted by mini-css-extract-plugin
export var button = "_1q-0";
export var buttonContent = "_1q-e";
export var buttonGroup = "_1q-c";
export var dontRestrainIconWidth = "_1q-a";
export var dropdownButton = "_1q-b";
export var iconContainer = "_1q-9";
export var lg = "_1q-4";
export var md = "_1q-3";
export var pending = "_1q-f";
export var sm = "_1q-2";
export var spinner = "_1q-d";
export var squared = "_1q-8";
export var wrapText = "_1q-g";
export var xl = "_1q-5";
export var xs = "_1q-1";
export var xxl = "_1q-6";
export var xxxl = "_1q-7";